module.exports = __webpack_public_path__ + "img/28.fixed_sink.d81748b7.svg";